import { createSlice } from '@reduxjs/toolkit';

export const userInformationSlice = createSlice({
  name: 'userInformation',
  initialState: {
    value: [],
  },
  reducers: {
    setUserInformation: (state, action) => {
      state.value = action.payload;
    },
    resetUserInformation: (state) => {
      state.value = [];
    },
  },
});

export const { setUserInformation, resetUserInformation } = userInformationSlice.actions;
export default userInformationSlice.reducer;
